import actions from './actions';

const {
  getAllSymbolBegin,
  getAllSymbolSuccess,
  getAllSymbolErr,
  setAllSymbolBegin,
  setAllSymbolSuccess,
  setAllSymbolErr,
} = actions;

const getAllSymbolAction = () => {
  return async dispatch => {
    try {
      dispatch(getAllSymbolBegin());
      dispatch(getAllSymbolSuccess());
    } catch (err) {
      dispatch(getAllSymbolErr(err));
    }
  };
};

const setAllSymbolAction = selectedSymbol => {
  return async dispatch => {
    try {
      dispatch(setAllSymbolBegin());
      dispatch(setAllSymbolSuccess(selectedSymbol));
    } catch (err) {
      dispatch(setAllSymbolErr(err));
    }
  };
};

export { getAllSymbolAction, setAllSymbolAction };
